"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryMapTextInfo = exports.CapturedData = exports.TextInfo = void 0;
//The textInfo class contains the textContent and captureTimes
function getCurrentTimestamp() {
    var currentMill = Date.now();
    return {
        seconds: Math.round(currentMill / 1000),
        nanos: ((currentMill % 1000) * 1000000)
    };
}
var TextInfo = /** @class */ (function () {
    //by default set the textContent to be 1
    function TextInfo(textContent) {
        this.value = textContent;
        this.visits = 1;
    }
    TextInfo.prototype.getCapturedTimes = function () {
        return this.visits;
    };
    TextInfo.prototype.getTextContent = function () {
        return this.value;
    };
    TextInfo.prototype.incrementCaptureTimes = function () {
        this.visits++;
    };
    return TextInfo;
}());
exports.TextInfo = TextInfo;
//The capturedData with specifc category and the list of textInfo belongs to it
var CapturedData = /** @class */ (function () {
    function CapturedData(category) {
        this.category = category;
        this.sentences = [];
    }
    CapturedData.prototype.insertTextInfo = function (text) {
        this.sentences.push(text);
    };
    return CapturedData;
}());
exports.CapturedData = CapturedData;
//The mapping from category -> textInfo
//Responsible for collecting the data during the mutation walking through
//Holds the encoded string (tag + textContent) and the TextInfo
var CategoryMapTextInfo = /** @class */ (function () {
    function CategoryMapTextInfo() {
        this.capturedData = new Map();
    }
    //Helper function encode the string to be used as the key
    //combined tag and textContent
    //since we manually split • in processing with strings, all strings should not contain •
    CategoryMapTextInfo.prototype.encodeCategoryText = function (category, textContent) {
        return category + "\u2022" + textContent;
    };
    CategoryMapTextInfo.prototype.decodeCategoryText = function (encodedText) {
        return encodedText.split('•');
    };
    //Insert the category and text pair while collecting
    CategoryMapTextInfo.prototype.insertTextByCategory = function (category, text) {
        var encodeString = this.encodeCategoryText(category, text);
        if (this.capturedData.has(encodeString)) {
            this.capturedData.get(encodeString).incrementCaptureTimes();
        }
        else
            this.capturedData.set(encodeString, new TextInfo(text));
    };
    //Reset the map after sending the message to avoid repetitive data
    CategoryMapTextInfo.prototype.resetMap = function () {
        this.capturedData.clear();
    };
    //Judge if the map is empty
    CategoryMapTextInfo.prototype.isEmpty = function () {
        return this.capturedData.size === 0;
    };
    //resolve to the message defined in the protobuf
    //https://github.com/doordash/services-protobuf/pull/11122/files
    //Transfer the capturedData into the telemetryMessage ready to sent
    //dataMap: keep track of the tag -> capturedData (faster to look up)
    //capturedCategoriedData: the data holds the tag -> Array<TextInfo>
    CategoryMapTextInfo.prototype.loadTelemetryMessage = function () {
        var _this = this;
        var dataMap = new Map();
        this.capturedData.forEach(function (value, key) {
            //extract the tag by decode the key
            var tag = _this.decodeCategoryText(key)[0];
            //If the dataMap is keep tracking on that, insert the textInfo
            if (dataMap.has(tag))
                dataMap.get(tag).insertTextInfo(value);
            else {
                //Create the source for dataMap and capturedCategoriedData
                var data = new CapturedData(tag);
                data.insertTextInfo(value);
                dataMap.set(tag, data);
            }
        });
        return {
            captured_data_infos: Array.from(dataMap.values()),
            timeStamp: getCurrentTimestamp()
        };
    };
    return CategoryMapTextInfo;
}());
exports.CategoryMapTextInfo = CategoryMapTextInfo;
